export interface IModelUserInDepartmentResponse {
  id: number;
  username: string;
  email: string;
  status: string;
  department: string;
  subDepartment: string;
  functionCode: string;
}

export class ModelUserInDepartment {
  id: number;
  username: string;
  email: string;
  status: string;
  department: string;
  subDepartment: string;
  functionCode: string;

  constructor(props = {} as IModelUserInDepartmentResponse) {
    props = props ?? {};
    this.id = props.id || 0;
    this.username = props.username || '';
    this.email = props.email || '';
    this.status = props.status || '';
    this.department = props.department || '';
    this.subDepartment = props.subDepartment || '';
    this.functionCode = props.functionCode || '';
  }
}

export interface IModelDepartmentUsersResponse {
  id: string;
  department: string;
  subDepartment: string;
  functionCode: string;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  users: IModelUserInDepartmentResponse[];
}

export class ModelDepartmentUsers {
  id: string;
  department: string;
  subDepartment: string;
  functionCode: string;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  userList: ModelUserInDepartment[];

  constructor(props = {} as IModelDepartmentUsersResponse) {
    props = props ?? {};
    this.id = props.id || '';
    this.department = props.department || '';
    this.subDepartment = props.subDepartment || '';
    this.functionCode = props.functionCode || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.userList = (props.users || []).map((e) => new ModelUserInDepartment(e));
  }
}

export interface IModelUserCountResponse {
  totalUser: number;
  userCount: number;
}

export class ModelUserCount {
  totalUser: number;
  userCount: number;

  constructor(props = {} as IModelUserCountResponse) {
    props = props ?? {};
    this.totalUser = props.totalUser || 0;
    this.userCount = props.userCount || 0;
  }
}
